export default __webpack_public_path__ + "static/media/radio_barva-min.8d87940d.png";